import { BadgeCheck, CalendarCheck, FileSignature } from "lucide-react";
import type { SponsorshipPointsScale } from "@/features/sponsorship/types/sponsorship.type";
import type { SponsorshipBareme } from "@/features/sponsorship/utils/deriveBareme";
import { P } from "@/shared/ui/typographies/paragraph";
import type { LucideIcon } from "lucide-react";

type BaremeSummaryProps = { bareme: SponsorshipBareme };

type BaremeRow = {
  icon: LucideIcon
  scaleKey: keyof SponsorshipPointsScale
  label: string
};

const ROWS: BaremeRow[] = [
  { icon: BadgeCheck, scaleKey: "cse_qualifie", label: "Contact CSE qualifié" },
  { icon: CalendarCheck, scaleKey: "rdv_confirme", label: "Rendez-vous confirmé" },
  { icon: FileSignature, scaleKey: "signe", label: "Signature d'un contrat" },
];

// Bloc barème structuré rendu depuis les données de la base (règlement
// publié), et non depuis le texte libre — les nombres affichés reflètent
// donc toujours le barème réellement appliqué.
export const BaremeSummary = ({ bareme }: BaremeSummaryProps) => (
  <div className="mb-6 flex flex-col gap-3 rounded-2xl border border-violet-100 bg-violet-50/60 px-5 py-4 dark:border-violet-900/60 dark:bg-violet-950/30">
    <P className="font-semibold text-gray-900 dark:text-white">Barème en vigueur</P>

    <dl className="flex flex-col gap-2">
      {ROWS.map((row) => (
        <div key={row.scaleKey} className="flex items-center justify-between gap-3">
          <dt className="inline-flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
            <span className="inline-flex size-7 items-center justify-center rounded-full bg-white text-violet-700 dark:bg-gray-800 dark:text-violet-300">
              <row.icon size={16} aria-hidden />
            </span>
            {row.label}
          </dt>
          <dd className="text-sm font-bold text-gray-900 dark:text-white">
            {bareme.pointsScale[row.scaleKey].toLocaleString("fr-FR")}
            {" "}
            pts
          </dd>
        </div>
      ))}
    </dl>

    <P size="sm" className="text-gray-600 dark:text-gray-400">
      Soit
      {" "}
      <span className="font-semibold text-gray-900 dark:text-white">
        {bareme.totalPointsPerSignedCse.toLocaleString("fr-FR")}
        {" "}
        pts
      </span>
      {" "}
      par recommandation signée · conversion : 1 000 pts =
      {" "}
      {bareme.eurForPoints(1000).toLocaleString("fr-FR")}
      {" "}
      € sur la boutique Yeati.
    </P>
  </div>
);

BaremeSummary.displayName = "BaremeSummary";
